import { ParallaxHeaderWithSvg, SiteLogo } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  ParallaxHeaderWithSvg,
  SiteLogo,
  React
};